import ClientsAxios from "../../client-axios";
import { RemarkCreateRequest, RemarksListRequest } from "../../dto/request/master/remarks.type";
import { ResponseEntity } from "../../dto/response";

const { API_SERVER } = ClientsAxios;

export const FetchRemarksListService = async (payload: RemarksListRequest | any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('/remark-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const CreateRemarkService = async (payload: RemarkCreateRequest, isUpdate: boolean = false) => {
    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const urlType = isUpdate ? 'update' : 'store';
        const response = await API_SERVER.post(`remark-master/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteRemarkService = async (payload: { id: number }) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('remark-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}